import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { CustomerDetailsService } from 'src/app/angularJS/services/customer-detail/customer-detail.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { FulfilmentRequestsService } from 'src/app/angularJS/services/fulfilment/fulfilment.service';
import FulfilmentRequest = InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest;

export class CustomerTicketsController {

  public static $inject = ['customerService', 'QueryBuilder', 'customer', '$location', 'customerDetailService', 'breadcrumbService', 'fulfilmentRequestsService', '$state'];
  public tickets: Array<InterACT.Interfaces.Tickets.Ticket>;
  public fulfilmentRequests: Array<InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest>;
  public ticketsPaginator: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };
  public fulfilmentPaginator: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };

  constructor(
    private customerService: CustomerService,
    private queryBuilder: QueryBuilder,
    private customer: InterACT.Interfaces.Customers.Customer,
    private $location: ng.ILocationService,
    private customerDetailService: CustomerDetailsService,
    private breadcrumbService: BreadcrumbService,
    private fulfilmentRequestsService: FulfilmentRequestsService,
    private $state: ng.ui.IStateService
  ) {
    this.customer = angular.copy(customer);
    this.activate();
  }

  public getTickets(page: number, perPage: number) {
    const sortInstr = [
      <InterACT.Interfaces.ISortInstruction>{ columnName: 'status', direction: 'DESC' },
      <InterACT.Interfaces.ISortInstruction>{ columnName: 'validity.endDateTime', direction: 'DESC' }
    ];

    let ticketsQuery;

    if (this.customer && this.customer.id) {
      ticketsQuery = this.queryBuilder.newParam().customerLinkIs(this.customer.id).sortBy(sortInstr).getParam();
    }
    else {
      if (this.$location.search().hasOwnProperty('cardNumber')) {
        const cardNumber = this.$location.search()['cardNumber'];
        ticketsQuery = 'card.reference=' + cardNumber;
      }
    }

    this.customerService.getTickets(page, perPage, ticketsQuery).then((ticketsResponse) => {
      this.tickets = ticketsResponse.tickets;
      this.ticketsPaginator.totalCount = ticketsResponse.meta.totalCount;

      // Look at the validity of all tickets retrieved and updated the status of any which have expired
      const now: Date = new Date();
      for (const ticket of this.tickets) {
        if (ticket.validity && ticket.validity.endDateTime) {
          const expiry: Date = new Date(ticket.validity.endDateTime);
          if (expiry < now) {
            (<any>ticket).status = 'EXPIRED';
          }
        }
      }
    });
  }

  public getFulfilmentRequests(page: number, perPage: number) {
    if (!perPage) {
      perPage = this.fulfilmentPaginator.perPageCount;
    }

    if (!page) {
      page = this.fulfilmentPaginator.currentPage;
    }

    let fulfilmentQuery;

    this.queryBuilder.newParam()

    if (this.customer && this.customer.id) {
      this.queryBuilder.customerLinkIs(this.customer.id);
    }
    else {
      if (this.$location.search().hasOwnProperty('cardNumber')) {
        const cardNumber = this.$location.search()['cardNumber'];
        this.queryBuilder.fieldIs('target.reference', cardNumber);
      }
    }

    fulfilmentQuery = this.queryBuilder.and()
      .openSubQuery()
      .not()
      .fieldIs('state.name', 'FULFILMENT_CANCELLED')
      .and()
      .not()
      .fieldIs('state.name', 'FULFILMENT_SUCCESSFUL')
      .and()
      .not()
      .fieldIs('actions.type', 'NEW_CARD')
      .and()
      .not()
      .fieldIs('actions.type', 'REPLACE_CARD')
      .closeSubQuery()
      .getParam()

    // Terms that query builder doesn't cater for.
    fulfilmentQuery += " AND NOT ( target.type='CUSTOMER_MEDIA' AND actions.type='BLOCK' )";
    fulfilmentQuery += ' sortBy timestamp desc';

    this.fulfilmentRequestsService.getFulfilmentRequests(page, perPage, fulfilmentQuery).then((fulfilmentResponse) => {
      this.fulfilmentRequests = fulfilmentResponse.fulfilmentRequests;
      this.fulfilmentPaginator.totalCount = fulfilmentResponse.meta.totalCount;
    });
  }

  /**
   * Get Fulfilment's Request State
   *
   */
  public getState(fulfilmentRequest: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest) {
    return this.fulfilmentRequestsService.getFulfilmentRequestState(fulfilmentRequest);
  }

  /**
   * This function is used to get the Action/s Type of a fulfilment request
   *
   * @param fulfilmentRequest the fulfilment request
   */
  public fulfilmentActionsType(fulfilmentRequest: FulfilmentRequest){
    return [...new Set(fulfilmentRequest.actions.map(function (c) {
      return c.type
    }))].join(" / ");
  }

  /**
   * Changes the state to the Fulfilment Request Summary view
   *
   * @param fulfilmentRequest The fulfilment Request object we wish to view in summary tab
   */
  public goToFulfilmentSummary = (fulfilmentRequest: FulfilmentRequest) => {
    this.$state.go('fulfilment-request.summary', {
      externalId: fulfilmentRequest.externalId
    });
  }

  private activate() {
    this.getTickets(1, 15);
    this.getFulfilmentRequests(1, 15);

    if (this.customer.id) {
      const enhancedDetails = this.customerDetailService.getEnhancedCustomerData(this.customer);
      const fullName = enhancedDetails && enhancedDetails.fullName ? enhancedDetails.fullName : 'CUSTOMER_TABS.ANONYMOUS';
      this.breadcrumbService.setBreadcrumbs([
        {
          name: 'SEARCH',
          sref: 'customers'
        }, {
          name: fullName,
          sref: 'customer.details',
          options: {
            reload: 'customer'
          }
        }, {
          name: 'CUSTOMER_TABS.TICKETS',
          sref: 'customer.tickets'
        }
      ]);
      return;
    }

    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'SEARCH',
        sref: 'customers'
      }, {
        name: 'CUSTOMER_TABS.ANONYMOUS',
        sref: 'customers',
        options: {
          reload: 'customer'
        }
      }, {
        name: 'CUSTOMER_TABS.TICKETS',
        sref: 'customer.tickets'
      }
    ]);

  }
}
